const KEYS = {
  RECENT_SEARCHES: 'hotto_recent_searches',
  SAVED_NUMBERS: 'hotto_saved_numbers',
  VISITS: 'hotto_visits',
  ONBOARDING_DONE: 'hotto_onboarding_done',
};

const MAX_RECENT = 8;
const MAX_SAVED = 20;

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

function yesterdayKey() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return d.toISOString().slice(0, 10);
}

export function getRecentSearches() {
  return readJson(KEYS.RECENT_SEARCHES, []);
}

export function addRecentSearch(keyword) {
  const trimmed = (keyword || '').trim();
  if (!trimmed) return getRecentSearches();

  const existing = getRecentSearches().filter((item) => item !== trimmed);
  const next = [trimmed, ...existing].slice(0, MAX_RECENT);
  writeJson(KEYS.RECENT_SEARCHES, next);
  return next;
}

export function clearRecentSearches() {
  localStorage.removeItem(KEYS.RECENT_SEARCHES);
}

export function getSavedNumbers() {
  return readJson(KEYS.SAVED_NUMBERS, []);
}

export function isNumberSaved(number) {
  return getSavedNumbers().some((item) => item.number === String(number));
}

export function toggleSavedNumber(number, label) {
  const normalized = String(number).trim();
  if (!normalized) return { saved: false, items: getSavedNumbers() };

  const items = getSavedNumbers();
  const index = items.findIndex((item) => item.number === normalized);

  if (index >= 0) {
    items.splice(index, 1);
    writeJson(KEYS.SAVED_NUMBERS, items);
    return { saved: false, items };
  }

  const next = [{ number: normalized, label: label || normalized, savedAt: Date.now() }, ...items]
    .slice(0, MAX_SAVED);
  writeJson(KEYS.SAVED_NUMBERS, next);
  return { saved: true, items: next };
}

export function removeSavedNumber(number) {
  const normalized = String(number).trim();
  const items = getSavedNumbers().filter((item) => item.number !== normalized);
  writeJson(KEYS.SAVED_NUMBERS, items);
  return items;
}

export function recordVisit() {
  const visits = readJson(KEYS.VISITS, { count: 0, streak: 0, lastDate: null });
  const today = todayKey();

  if (visits.lastDate === today) {
    return {
      visitCount: visits.count,
      streak: visits.streak || 1,
      isReturning: visits.count > 1,
    };
  }

  let streak = 1;
  if (visits.lastDate === yesterdayKey()) {
    streak = (visits.streak || 0) + 1;
  } else if (visits.lastDate) {
    streak = 1;
  }

  const next = {
    count: (visits.count || 0) + 1,
    streak,
    lastDate: today,
  };
  writeJson(KEYS.VISITS, next);

  return {
    visitCount: next.count,
    streak: next.streak,
    isReturning: next.count > 1,
  };
}

export function isOnboardingDone() {
  return localStorage.getItem(KEYS.ONBOARDING_DONE) === 'true';
}

export function setOnboardingDone() {
  localStorage.setItem(KEYS.ONBOARDING_DONE, 'true');
}

export function buildShareUrl(keyword) {
  return `https://hotto.app/search/${encodeURIComponent((keyword || '').trim())}`;
}

export function buildShareText(keyword, mode = 'dream') {
  const trimmed = (keyword || '').trim();
  if (mode === 'number') {
    return `เช็คสถิติเลข ${trimmed} ย้อนหลัง 32 ปี ที่ Hotto`;
  }
  return `ทำนายเลขเด็ดจากฝัน "${trimmed}" ที่ Hotto — หาเลขนำโชคฟรี!`;
}

export function buildLineShareUrl(keyword, mode = 'dream') {
  const text = `${buildShareText(keyword, mode)} ${buildShareUrl(keyword)}`;
  return `https://line.me/R/msg/text/?${encodeURIComponent(text)}`;
}
